import axios from "@/axios.js";
import tn from "../../http/requests/tenants/index.js";
import hr from "../../http/requests/hrms/index.js";
import photoUpload from "../../http/requests/photo/index.js";
export default {
  addTenants({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/tenants", item)
        .then((response) => {
          commit("ADD_LEAVE", response.data.data); //Object.assign(item, {employeeFiledTenantsId: response.data.data.employeeFiledTenantsId}))
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateTenants({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/tenants", item)
        .then((response) => {
          //console.log(response.data.data)
          commit("UPDATE_LEAVE", response.data.data); //Object.assign(item, {employeeFiledTenantsId: response.data.data.employeeFiledTenantsId}))
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  editCalendarTenants({ commit }, tenants) {
    commit("EDIT_LEAVE", tenants);
  },
  removeCalendarTenants({ commit }, tenantsId) {
    commit("REMOVE_LEAVE", tenantsId);
  },
  getAllTenants({ commit }, payload) {
    return new Promise((resolve, reject) => {
      tn.getAllTenants(
        payload.sortBy,
        payload.sortOrder,
        payload.pageNumber,
        payload.pageSize
      )
        .then((response) => {
          commit("GET_ALL_TENANTS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllTenants({ commit }, payload) {
    return new Promise((resolve, reject) => {
      tn.getAllTenants(
        payload.sortBy,
        payload.sortOrder,
        payload.pageNumber,
        payload.pageSize
      )
        .then((response) => {
          commit("GET_ALL_TENANTS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getTenantbyID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log("Tenants ID:", payload.tenantsId);

      axios
        .get(`/api/tenants/${payload.tenantsId}`)
        .then((response) => {
          commit("GET_TENANTSID", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllSettings({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/tenants/settings/${payload.tenantsId}`)
        .then((response) => {
          localStorage.setItem(
            "tenantsSettings",
            JSON.stringify(response.data.data)
          );
          commit("GET_ALL_SETTINGS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllSignatories({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/tenants/signatories/${payload.tenantsId}`)
        .then((response) => {
          commit("GET_ALL_SIGNATORIES", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllTenantsSchedule({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`api/tenants/schedule/${payload.tenantsId}`)
        .then((response) => {
          commit("GET_ALL_TENANTSSCHEDULE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllApproversByModule({ commit }, item) {
    return new Promise((resolve, reject) => {
      hr.getAllApproversByModule(item.module, item.userId)
        .then((response) => {
          commit("GET_ALL_APPROVERS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  uploadPhoto({ commit }, item) {
    //console.log('pasok eh noh')
    var config = {
      headers: { "Content-Type": "multipart/form-data" },
    };
    return new Promise((resolve, reject) => {
      // photoUpload.uploadPhoto(item.UserId, item.Title, Description, IsPublic, Type, FileName, file)
      axios
        .post("/api/photo/upload", item, config)

        .then((response) => {
          //console.log('x')
          commit("UPLOAD_PHOTO", Object.assign(item, { id: response.data.id }));
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
